import _ from 'lodash'
import React from 'react'
import PropTypes from 'prop-types'
import UserPart from './aside/User'
import MenuLink from './aside/MenuLink'
import {
  Menu
} from 'semantic-ui-react'

const defaultMenuLinks = [
  {to: '/', icon: 'dashboard', name: 'Dashboard'},
  {to: '/jobs', icon: 'tasks', name: 'Jobs'},
  {to: '/minions', icon: 'cubes', name: 'Minions'},
  {to: '/job/run', icon: 'play', name: 'Run job'},
  {to: '/job/templates', icon: 'magic', name: 'Jobs templates'},
]

// export defaultZZZ (props) => {
//   const menuLinks = _.map(
//     (props.menuLinks || defaultMenuLinks),
//     (e, i) => {
//       return <MenuLink key={i} {...e}/>
//     })
//   console.log('Aside:', props)
//   return (
//     <aside>
//       <div id='sidebar' className='nav-collapse '>
//         <ul className='sidebar-menu' id='nav-accordion'>
//           <UserPart {...props}/>
//           {menuLinks}
//         </ul>
//       </div>
//     </aside>
//   )
// }

const Aside = (props) => {
  const menuLinks = _.map(
    (props.menuLinks || defaultMenuLinks),
    (e, i) => {
      //return <MenuLink key={i} {...e}/>
      return <Menu.Item key={i} as={MenuLink} name={e.title} {...e}/>
    })
  console.log('Aside:', props)
  return (
    <aside>
      {/*
          <div id='sidebar' className='nav-collapse '>
          <ul className='sidebar-menu' id='nav-accordion'>
          <UserPart {...props}/>
          {menuLinks}
          </ul>
        */}
      <UserPart {...props}/>
      <Menu icon={false} vertical pointing fixed={'left'} size={'large'}>
        {menuLinks}
      </Menu>
      {/*</div>*/}
    </aside>
  )
}
Aside.displayName = 'Aside'
Aside.propTypes = {
  menuLinks: PropTypes.arrayOf(PropTypes.object)
}
export default Aside



// WEBPACK FOOTER //
// ./src/components/Aside.js